/**
 * React Query hooks for issue activities data fetching.
 */

import { useQuery } from "@tanstack/react-query";
import { listIssueActivities } from "@/services/issueActivitiesService";
import { useApiReady } from "@/hooks/useApi";

/**
 * Hook to fetch a paginated list of activities for a security issue.
 * @param issueId - The numeric ID of the issue
 * @param page - The page number (default: 1)
 */
export function useIssueActivities(issueId: number, page: number = 1) {
  const isApiReady = useApiReady();

  return useQuery({
    queryKey: ["issue-activities", issueId, page],
    queryFn: () => listIssueActivities(issueId, page),
    staleTime: 30000, // 30 seconds
    enabled: issueId > 0 && isApiReady,
  });
}
